export default __webpack_public_path__ + "static/media/cert-senior-manager-cpttm-sc.2bcf8624.jpg";